/**
 * Parse number from string; required for input[type="range" | "number"].
 * @ngdoc https://docs.angularjs.org/error/ngModel/numfmt
 * @name stringToNumber
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('stringToNumber', stringToNumber);

    function stringToNumber() {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (value) {
                    return '' + value;
                });
                ngModel.$formatters.push(function (value) {
                    return parseFloat(value);
                });
            }
        };
    }
})();
